import styles from "./PageEdit.module.css"
import QuillEditor from "../util/QuillEditor";
import { useState } from "react";
import Profil from "./websiteComponents/Profil"
import SelectImage from "./SelectImage";


// component
import TextInput from "./TextInput";


export default function PageInfoProfileEdit({sectionKey, header, id, name, imageUrl, mail, mobile, addInfo, updateField, parentSectionKey}) {

    const [image, setImage] = useState(imageUrl)
    const updateImage = (url)=> {
        setImage(url)
        updateField(parentSectionKey, sectionKey+".imageUrl", url)
    }

    return(
        <div className={styles.item}>
            <h3 style={{width:"100%", textAlign:"center", marginTop:"1rem"}}>{name}</h3>
            <div className={styles.profile}>
                
                <div>
                    <Profil image={image}/>
                    <SelectImage onSelect={(url) => updateImage(url)}/>
                </div>
        
                <div className={styles.item} style={{width:"100%", maxWidth:"750px", marginTop:"1rem"}}>
                    {/* Header Input */}
                    <TextInput
                        label={"Title:"}
                        value={header}
                        onChange={(e) => updateField(parentSectionKey, sectionKey+".header", e.target.value)}
                    />

                    {/* Id Input */}
                    <TextInput
                        label={"id:"}
                        value={id}
                        onChange={(e) => updateField(parentSectionKey, sectionKey+".id", e.target.value)}
                    />

                    {/* Name Input */}
                    <TextInput
                        label={"Name:"}
                        value={name}
                        onChange={(e) => updateField(parentSectionKey, sectionKey+".name", e.target.value)}
                    />

                    {/* mail Input */}
                    <TextInput
                        label={"Mail:"}
                        value={mail}
                        onChange={(e) => updateField(parentSectionKey, sectionKey+".mail", e.target.value)}
                    />

                    {/* mobile Input */}
                    <TextInput
                        label={"Mobile:"}
                        value={mobile}
                        onChange={(e) => updateField(parentSectionKey, sectionKey+".mobile", e.target.value)}
                    />

                    {/* addition info Input */}
                    <label>Ekstra info:</label>
                    <QuillEditor
                        value={addInfo || ""}
                        onChange={(value) => updateField(parentSectionKey, sectionKey+".addInfo", value)}
                        placeholder="Write your content here..."
                    />
                </div>
            </div>
        </div>
    );
}